import {
	Button,
	Col,
	Divider,
	Form,
	Input,
	Row,
	Select,
	Upload,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import { UploadOutlined } from "@ant-design/icons";

const optionsType = [
	{
		value: "ETICKET",
		label: "ETICKET",
	},
	{
		value: "JAP",
		label: "JAP",
	},
];

const optionsCompany = [
	{
		value: "Castle",
		label: "Castle",
	},
	{
		value: "Logistics",
		label: "Logistics",
	},
	{
		value: "57Concrete",
		label: "57Concrete",
	},
	{
		value: "Fuels",
		label: "Fuels",
	},
];

const NewTask = ({ history }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [loadingButton, setLoadingButton] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [evidenceAdded, setEvidenceAdded] = useState(false);
	const [taskNumber, setTaskNumber] = useState(null);
	const [userList, setUserList] = useState([]);
	const [userLoading, setUserLoading] = useState(true);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getUsers();
		getTaskID();
	}, []);

	const getTaskID = async () => {
		try {
			const url = api + "/tasknumber";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			setTaskNumber(data.taskNumber);
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get task id");
			console.error(err.message);
			return null;
		}
	};

	const createTask = async (values) => {
		const task = {
			...values,
			number: taskNumber,
			createdBy: localStorage.getItem("userId"),
		};

		delete task.evidence;

		try {
			const url = api + "/task/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, task);
			if (data.success) {
				if (evidenceAdded) {
					addEvidence(values, data.payload._id);
				} else {
					openNotification("success", "Success", data.message);

					setTimeout(() => {
						setLoadingButton(false);
						history.push("/task/dashboard");
					}, 2000);
				}
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", "Error while trying to create task");
			console.error(err.message);
			return null;
		}
	};

	const addEvidence = async (values, id) => {
		const formData = new FormData();

		if (evidenceAdded && values.evidence && values.evidence.length > 0) {
			values.evidence.forEach((file) => {
				formData.append("files", file.originFileObj);
			});
		}

		try {
			const url = api + `/task/add/files/${id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification("success", "Success", "Task Created");

				setTimeout(() => {
					setLoadingButton(false);
					history.push("/task/dashboard");
				}, 2000);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add task images"
			);
			console.error(err.message);
			return null;
		}
	};

	const getUsers = async () => {
		try {
			const url = api + "/user/list/task";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						label: `${item.role} - ${item.name.toUpperCase()}`,
						value: item._id,
					});
				});
				setUserList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setUserLoading(false);
		} catch (err) {
			setUserLoading(false);
			openNotification("error", "Error", "Error while trying to get users");
			console.error(err.message);
			return null;
		}
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onChangeEvidence = ({ fileList }) => {
		if (fileList.length === 0) {
			setEvidenceAdded(false);
		} else {
			setEvidenceAdded(true);
		}
	};

	const onFinish = (values) => {
		setLoadingButton(true);
		createTask(values);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
				initialValues={{
					number: taskNumber,
				}}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Title"
							name="title"
							rules={[
								{
									required: true,
									message: "Title is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							label="Description"
							name="description"
							rules={[
								{
									required: true,
									message: "Description is required",
								},
							]}
						>
							<Input.TextArea size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Type"
							name="type"
							rules={[
								{
									required: true,
									message: "Types are required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select types"
								mode="multiple"
								options={optionsType}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								allowClear
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Company"
							name="company"
							rules={[
								{
									required: true,
									message: "Company is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select company"
								options={optionsCompany}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								allowClear
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Authorized By"
							name="authorizedBy"
							rules={[
								{
									required: true,
									message: "Authorized By is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select authorized by"
								options={userList}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								loading={userLoading}
							/>
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item label="Bill ID" name="billId">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item
							label="Evidence (Max Count: 10)"
							name="evidence"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								onChange={onChangeEvidence}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} sm={12} md={4}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
						>
							Create
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout title="New Task" description="Create new task" type="medium">
			{contextHolder}
			{loading ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default NewTask;
